/** One entry in a chart legend: a colored swatch + its series/slice label. */
export interface ChartLegendItem {
  key: string;
  label: string;
  color: string;
}

const FALLBACK_COLOR = '#8b5cf6';

/**
 * Build legend items from parallel label/color arrays. Colors cycle when the
 * array is shorter than the labels (pie slices share a palette) or align 1:1
 * (one color per series). Single source of truth so the chat (ChartBlock) and
 * dashboard (DashboardPanel) legends can't drift in shape.
 */
export function buildLegendItems(labels: string[], colors: string[]): ChartLegendItem[] {
  return labels.map((label, i) => ({
    key: String(i),
    label,
    color: colors[i % colors.length] ?? FALLBACK_COLOR,
  }));
}
